"use strict";
var ACC;
ACC.product = {

	_autoload: [
		"bindToAddToCartForm",
		"enableStorePickupButton",
		"enableAddToCartButton",
		"enableVariantSelectors",
		"bindFacets"
	],


	bindFacets:function(){
		$(document).on("click",".js-show-facets",function(e){
			e.preventDefault();

			ACC.colorbox.open("Select Refinements",{
				href: "#product-facet",
				inline: true,
				width:"320px",
				onComplete: function(){

					$(document).on("click",".js-product-facet .js-facet-name",function(e){
						e.preventDefault();
						$(".js-product-facet  .js-facet").removeClass("active");
						$(this).parents(".js-facet").addClass("active");
						$.colorbox.resize();
					});
				},
				onClosed: function(){
					$(document).off("click",".js-product-facet .js-facet-name");
				}
			});
		});


		var screenSmMax = 768;
		enquire.register("screen and (min-width:"+screenSmMax+")",  function() {
			$("#cboxClose").click();
		});


	},

	enableAddToCartButton: function ()
	{
		$('.js-add-to-cart').removeAttr("disabled");
	},

	enableVariantSelectors: function ()
	{
		$('.variant-select').removeAttr("disabled");
	},

	bindToAddToCartForm: function ()
	{
		var addToCartForm = $('.add_to_cart_form');
		var csrfTokenInput = addToCartForm.find('input[name="CSRFToken"]');
		var productCodeInput = $('input[name="productCodePost"]');
		var isProductBundle = $('form#product-bundle').length > 0;
		var beforeSerializeCallback = function () {
			ACC.config.CSRFToken = ACC.common.getCSRFTokenJS();
			csrfTokenInput.val(ACC.config.CSRFToken);
		};
		var beforeSubmitCallback = isProductBundle ? ACC.product.validateVariantStyle : ACC.product.validateVariantSize;
		var itemPositionList = window.localStorage.getItem("ITEM_POSITION_TRACK_KEY");

		const quantityInput = addToCartForm.find('[class~=js-qty-selector-input]');
		let productId = "";

		if (isProductBundle) {
			// this is a bundle. find the product codes inside the bundle
			// the prod code will be changed inside a hidden input once variant changes
			var prodBundleId = $(".pdp-add-lovelist-section").data("product-bundleid");
			if(itemPositionList) {
				var result = JSON.parse(itemPositionList).filter(function(el) {
					return prodBundleId.includes(el.bundleId)
				}).slice(-1);
				addToCartForm.find("#position").val(result.length > 0 ? result[0].position : "null");
				productId = prodBundleId;
			} else {
				addToCartForm.find("#position").val("null");
			}
		} else {
			// normal product. there will be only one prod code
			// the code will be reflected inside a hidden input
			// there are SOME situations where the input is not found on the page
			var productCode = productCodeInput.length > 0 ? productCodeInput[0].value : "-1";
			if(itemPositionList) {
				var resultPos = JSON.parse(itemPositionList).filter(function(el) {
					return productCode.includes(el.id)
				}).slice(-1);
				addToCartForm.find("#position").val(resultPos.length > 0 ? resultPos[0].position : "null");
				productId = resultPos?.length > 0 ? resultPos[0].id : null;
			} else {
				addToCartForm.find("#position").val("null");
			}
		}

		const baseEventData = {
			eventType: "addToBag",
			location: "productDetailPage",
			timestamp: new Date().toISOString(),
			details: productId,
		};

		const getCurrentQuantity = function() {
			return quantityInput.val() || 1;
		};

        addToCartForm.ajaxForm({
            beforeSerialize: beforeSerializeCallback,
            beforeSubmit: beforeSubmitCallback,
			success: function(response) {
				const currentQuantity = getCurrentQuantity();
				const responseData = JSON.parse(response);

				const value = responseData?.recommendations ? responseData?.recommendations?.components[0]?.values?.[0]?.value : null;
				const baseUrl = typeof value === 'string' ? JSON.parse(value) : value;
				const queryParams = baseUrl ? baseUrl.query_parameters
				.map(param => `${encodeURIComponent(param.name)}=${encodeURIComponent(param.value)}`)
				.join("&") : null;
				const finalUrl = queryParams ? `${baseUrl.base}${queryParams}` : '';
				// Updated eventData for success
				const eventData = {
					...baseEventData,
					quantity: currentQuantity,
					isSuccess: true,
					modal: true,
					productCarouselUrl: finalUrl || '',
					productCarouselHidden: responseData?.recommendations?.components?.length ? responseData?.recommendations?.components?.length === 0 : true
				};

				// Send the data to the mobile app
				ACC.common.sendToMobileApp(eventData);
				ACC.product.displayAddToCartPopup(response);
				if (isProductBundle) {
					window.ACC.vueAddtoBagModal?.open();
				}
			},
			error: function(xhr, status, error) {
				const currentQuantity = getCurrentQuantity();

				// Updated eventData for error
				const eventData = {
					...baseEventData,
					quantity: currentQuantity,
					isSuccess: false
				};

				// Send the data to the mobile app
				ACC.common.sendToMobileApp(eventData);
			}
        });
	},

	validateVariantStyle: function ()
	{
		if($("form#product-bundle #prod-bundle-variant").data('value') === 'default') {
			$("#variant_select_size_error").show().addClass('visible');
			return false;
		}
	},

	validateVariantSize: function ()
	{
		if($("form#product input[type=radio]:checked").length < 1){
			$("#variant_select_size_error").show().addClass('visible');
			return false;
		}
	},

	bindToAddToCartStorePickUpForm: function ()
	{
		var addToCartStorePickUpForm = $('#colorbox #add_to_cart_storepickup_form');
		addToCartStorePickUpForm.ajaxForm({success: ACC.product.displayAddToCartPopup});
	},


	enableStorePickupButton: function ()
	{
		$('.js-pickup-in-store-button').removeAttr("disabled");
	},

	displayAddToCartPopup: function (cartResult, statusText, xhr, formElement)
	{
		var quantity = $('[class~=js-qty-selector-input]', formElement).val() || 1;
        var product = $('input[name="productCodePost"]', formElement).val();
        var cartData = JSON.parse(cartResult);
        if (cartData['gtmCustomerData']) {
            ACC.gtm.saveGtmCustomerDetails(JSON.parse(cartData['gtmCustomerData']));
        }
        var variant = ACC.common.getVariant();
		//store cart json in Local Storage
		ACC.common.storeInLocalStorage(ACC.common.localCartJsonKey, cartData);
		if(cartData?.recommendations?.components?.length) {
			ACC.vueAddtoBagModal?.updateSearchConfigData(cartData.recommendations.components); 
		}

		if (ACC.vueMiniCart?.isHovered) {
			ACC.vueMiniCart.showMiniCart(window.ACC.vueMiniCart.watchClick);
		}

		ACC.gtm.trackAddToCart(product, quantity, variant);
	}

};
